




import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'DigitalContentNotification',
  setup() {
    return {
      pageTitle: 'デジタルフォト・ムービーメッセージ',
    };
  },
});
